module.exports = __webpack_public_path__ + "img/simple_white_logo.43b3fa8d.svg";